/* GENERATED from src/js/ndog-atc-loading.js — edit the source, then run `make js`. Never edit this file by hand. */
// Add-to-cart button loading state — toggles .is-loading on #add until the cart responds.
(function () {
  const button = document.querySelector('#add.product-add');
  if (!button) return;

  const form = button.closest('form');
  if (!form) return;

  let fallbackTimer = null;
  let drawerObserver = null;

  function isDrawerOpen() {
    return document.body.classList.contains('menu-opened') || !!document.querySelector('#sliding-cart.active');
  }

  function stopLoading() {
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    window.removeEventListener('focus', stopLoading);
    if (drawerObserver) {
      drawerObserver.disconnect();
      drawerObserver = null;
    }
    if (fallbackTimer) {
      clearTimeout(fallbackTimer);
      fallbackTimer = null;
    }
  }

  function onDomChange() {
    if (isDrawerOpen()) stopLoading();
  }

  function startLoading() {
    if (button.classList.contains('is-loading')) return;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    drawerObserver = new MutationObserver(onDomChange);
    drawerObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    const drawer = document.querySelector('#sliding-cart');
    if (drawer) drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener('focus', stopLoading);
    fallbackTimer = window.setTimeout(stopLoading, 8000);
  }

  form.addEventListener('submit', startLoading);
})();
